module.exports = __webpack_public_path__ + "img/book_06.a7c23e8a.jpg";